<form [formGroup]="formOtpPin">
  <div *ngIf="label" class="row d-flex align-items-center justify-content-center">
    <label>{{label}}</label>
  </div>
  <div *ngIf="subLabel" class="row d-flex align-items-center justify-content-center">
    <label class="sublabel">{{subLabel}}</label>
  </div>


  <div class="row d-flex align-items-center justify-content-center mt15">

    <div class="input-group justify-content-end flex-nowrap"
      style="{{i === (formInput.length / 2) ? 'margin-left: 50px;' : '' }}"
      *ngFor="let input of formInput;  index as i">

      <input *ngIf="!showPin" #formRow type="password" autocomplete="off" formControlName="{{input}}" class="form-control form-control--otp js-otp-input"
        maxlength="1" (keyup)="keyUpEvent($event, i)">
      <input *ngIf="showPin" #formRow type="text" formControlName="{{input}}" class="form-control form-control--otp js-otp-input"
        maxlength="1" (keyup)="keyUpEvent($event, i)">
    </div>

    <div *ngIf="isPin" class="input-group justify-content-end flex-nowrap pl-20">
      <span *ngIf="!showPin" class="glyphicon glyphicon-eye-open" (click)="showPin = !showPin"></span>
      <span *ngIf="showPin" class="glyphicon glyphicon-eye-close" (click)="showPin = !showPin"></span>
    </div>

  </div>


</form>